<template>
  <div v-if="items" class="gp-content">
    <table-tile-bar :view.sync="view" :refresh="refresh">
      <p class="level-item is-size-4 bar-title">Actions Configs</p>
      <pagination
        class="level-item"
        :next="hasNext"
        :prev="hasPrev"
        :nextClick="nextPage"
        :prevClick="prevPage"
        :page="page"
        :perPage="perPage"
        :itemCount="itemCount"
        :total="total"
        :loading="loading">
      </pagination>
      <router-link class="button add" :to="{ name: 'actions.index.create' }">
        <i class="fas fa-plus"></i>
        Create Actions Config
      </router-link>
    </table-tile-bar>
    <div class="scroll-vertical">
      <actions-table
        v-if="view === 'table'"
        :actions="items"
        :sortDirection="sortDirection"
        :sortField="sortField"
        :onSort="onSort"></actions-table>
      <actions-tiles v-else :actions="items"></actions-tiles>
    </div>
  </div>
</template>

<script>
import pagination from '@/mixins/pagination';
import TableTileBar from '@/components/TableTileBar.vue';
import ActionsTiles from '@/components/actions/ActionsTiles.vue';
import ActionsTable from '@/components/actions/ActionsTable.vue';
import Pagination from '@/components/Pagination.vue';

export default {
  name: 'Actions',
  mixins: [pagination],
  components: {
    TableTileBar,
    ActionsTable,
    ActionsTiles,
    Pagination,
  },
  data() {
    return {
      endpoint: 'primary/listActionConfigs',
      sortDirection: 'DESC',
      sortField: 'created',
    };
  },
  computed: {
    view: {
      set(value) { this.$store.commit('actionViewState/SET_VIEW', value); },
      get() { return this.$store.state.actionViewState.view; },
    },
    requestVars() {
      return {
        direction: this.sortDirection,
        field: this.sortField,
      };
    },
  },
  async mounted() {
    this.refresh(null);
  },
  methods: {
    onSort(field, order) {
      this.sortDirection = order.toUpperCase();
      this.sortField = field;
      this.reset();
    },
  },
};
</script>
